import React from "react";
import {useAppContext} from "../../context/AppState.jsx";
import {GenericSubmenu} from "../../components";

export default ({ items }) => {

	return <GenericSubmenu items={items} />
};
